export const GET_ALL_CHATS = 'Chat/GET_ALL_CHATS';
export const RESET_ALL_CHAT_OPTION = 'Chat/RESET_ALL_CHAT_OPTION';